export default __webpack_public_path__ + "static/media/cheese-wine.3476a94c.png";